import { memo } from 'react';

import { merge } from '@/components';
import { Text } from '@/components/core';
import { DivProps } from '@/utils';

const ISortColumnCard = ({ name, className, children, ...rest }: DivProps & { name: string }) => {
  return (
    <div className={merge('flex w-full items-center gap-1', className)} {...rest}>
      <Text>{name}</Text>
      {children}
    </div>
  );
};

export const SortColumnCard = memo(ISortColumnCard) as typeof ISortColumnCard;
